import {
  type InvoiceData,
  type SellerData,
  type BuyerData,
  type SupportedCurrencies,
} from "../schema";
import dayjs from "dayjs";

const ISRAELI_DATE_FORMAT = "DD/MM/YYYY";

function getToday(): string {
  return dayjs().format(ISRAELI_DATE_FORMAT);
}

const TODAY = dayjs().format(ISRAELI_DATE_FORMAT);
const ILS: SupportedCurrencies = "ILS";

const DEFAULT_SELLER_DATA = {
  name: "",
  address: "",
  addressSelectedFromList: false,
  vatNo: "",
  phone: "",
  emailFieldIsVisible: false,
} as const satisfies Omit<SellerData, "id">;

const DEFAULT_BUYER_DATA = {
  name: "",
  vatNo: "",
} as const satisfies Omit<BuyerData, "id">;

const INITIAL_INVOICE_DATA = {
  currency: ILS,
  logo: "",
  receiptNumber: {
    series: new Date().getFullYear().toString(),
    number: "40001",
  },
  dateOfIssue: TODAY,
  dateFormat: ISRAELI_DATE_FORMAT,
  seller: DEFAULT_SELLER_DATA,
  buyer: DEFAULT_BUYER_DATA,
  items: [
    {
      name: "",
      nameFieldIsVisible: true,
      amount: "",
      netPrice: "",
      preTaxAmount: "",
      paymentMethod: "",
      paymentMethodFieldIsVisible: true,
      paymentDate: "",
      paymentDateFieldIsVisible: false,
      paymentPhoneNumber: "",
      paymentPhoneNumberFieldIsVisible: true,
      paymentBankName: "",
      paymentBankNameFieldIsVisible: true,
      paymentBankNumber: "",
      paymentBankNumberFieldIsVisible: true,
      paymentBranch: "",
      paymentBranchFieldIsVisible: true,
      paymentAccount: "",
      paymentAccountFieldIsVisible: true,
      // Credit card fields - visible by default
      paymentCardCompany: "",
      paymentCardCompanyFieldIsVisible: true,
      paymentCardType: "",
      paymentCardTypeFieldIsVisible: true,
      paymentTransactionNumber: "",
      paymentTransactionNumberFieldIsVisible: true,
      paymentNumberOfPayments: "",
      paymentNumberOfPaymentsFieldIsVisible: true,
      paymentCardLastFour: "",
      paymentCardLastFourFieldIsVisible: true,
      // Check fields - visible by default
      paymentCheckNumber: "",
      paymentCheckNumberFieldIsVisible: true,
      paymentCheckBankName: "",
      paymentCheckBankNameFieldIsVisible: true,
      paymentCheckBranch: "",
      paymentCheckBranchFieldIsVisible: true,
      paymentCheckAccount: "",
      paymentCheckAccountFieldIsVisible: true,
      paymentCheckMaturityDate: "",
      paymentCheckMaturityDateFieldIsVisible: true,
    },
  ],
  total: 0,
  paymentMethod: "",
  notes: "",
  notesFieldIsVisible: true,
  paymentMethodFieldIsVisible: true,
  businessType: "osek-patur",
} as const satisfies InvoiceData;

export function getInitialInvoiceData(): InvoiceData {
  const today = getToday();
  const currentYear = new Date().getFullYear();

  return {
    ...INITIAL_INVOICE_DATA,
    dateOfIssue: today,
    receiptNumber: {
      ...INITIAL_INVOICE_DATA.receiptNumber,
      series: currentYear.toString(),
    },
  };
}
